import React from 'react';
import { useEditMode } from './EditModeProvider';

const EditableImage = ({ contentKey, defaultSrc, defaultValue, className = '', alt = '', style = {}, ...props }) => {
  const { getContent } = useEditMode();

  const fallbackSrc = defaultSrc || defaultValue;
  const currentSrc = getContent(contentKey, fallbackSrc);

  return <img src={currentSrc} className={className} alt={alt} style={style} {...props} />;
};

export default EditableImage;